import { faComment } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import React from 'react';
import styles from './CommentsButton.mscss';

interface OwnProps {
    commentsCount?: number;
    className?: string;

    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

type Props = OwnProps;

class CommentsButton extends React.PureComponent<Props> {

    public render() {
        const { className, commentsCount, onClick } = this.props;

        return (
            <button type="button" className={cx(styles.CommentsButton, className)} onClick={onClick}>
                <FontAwesomeIcon icon={faComment} className={styles.CommentsButton__icon} />
                {commentsCount && commentsCount}
            </button>
        );
    }

}

export default CommentsButton;
